import { Box } from "@mui/material";

interface ImageBox24pxProps {
  src?: string;
  alt?: string;
}

function ImgBox24px({ src, alt }: ImageBox24pxProps) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: "24px",
        height: "24px",
        objectFit: "cover",
        ml: "8px",
      }}
    />
  );
}

export default ImgBox24px;
